import React, {useState} from 'react'
import useStyles from './styles'
import {Grid} from '@material-ui/core'
import messages from './messages'
import ConfirmationModal from '../Common/ConfirmationModal'

export default function Footer() {
    const classes = useStyles()
    const {langLinks, footerBottomActions, translationDisclaimer} = messages
    const [modal, setModal] = useState({title: translationDisclaimer, dialogTitle: 'Translation Disclaimer', open: false})
    return (
        <div >
            <div className={classes.footerPrimary}>
                <Grid container direction='column'
                    className={classes.primaryTop}
                >
                    <a target="_blank" rel="noopener noreferrer" className={classes.primaryTopLink1} href='https://www.dhcs.ca.gov/Pages/Language_Access.aspx'>
                        Non-Discrimination Policy and Language Access
                    </a>
                    <a target="_blank" rel="noopener noreferrer" className={classes.primaryTopLink2} href='https://www.dhcs.ca.gov/Pages/Health_Care_Language_Assistance_Services.aspx'>
                        Access Health Care Language Assistance Services (SB 223)
                    </a>
                    <Grid className={classes.langLinksWrapper} container spacing={3} item>
                        { langLinks.map( (link, i) => 
                            <Grid key={i} item>
                                <a target="_blank" rel="noopener noreferrer" className={classes.langLinks} href={link.to}>
                                    {link.text}
                                </a>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </div>
            <div className={classes.footerSecondary}>
                <Grid className={classes.bottomLinkWrapper} container spacing={3} justify='center'>
                    { footerBottomActions.map( (e, i) => 
                        <Grid key={i} item >
                            <span className={classes.footerBottomLinks} onClick={() => e.action(setModal)}>
                                <a target="_blank" rel="noopener noreferrer" className={classes.footerBottomLinks} href={e.link}>{e.text}</a>
                            </span>
                        </Grid>
                    )}
                </Grid>
            </div>
            <ConfirmationModal 
                open={modal.open}
                title={modal.title}
                dialogTitle={modal.dialogTitle}
                isWarning={false}
                confirm={() => setModal( prev => ({...prev, open: false}))}
                confirmText={'Close'}
            />
        </div>
    )
}